// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"689":"ac3fd965","963":"ac3fd965"}[chunkId] + ".chunk.css";
};